import { Card } from '@ipfabric/ui-components/Card/Card';
import { Table } from 'components/Table/components/Table';
import { renderQuery } from 'utils/react-query/renderQuery';
import { RuleForm } from './RuleForm';
import { useRulesTable } from './useRulesTable';

const rulesTableDescription =
  'Define rules that automatically assign labels to devices or interfaces based on their properties. ' +
  'Each rule evaluates matching objects against regex patterns and assigns the specified labels ' +
  'when a snapshot is created.';

type RulesTabContentProps = {
  initialRuleId?: string;
};

export const RulesTabContent = ({ initialRuleId }: RulesTabContentProps) => {
  const rulesTable = useRulesTable({ initialRuleId });
  const closeRuleForm = () => {
    rulesTable.setEditedRule(null);
  };
  const saveRuleForm = () => {
    void rulesTable.invalidateRules();
    rulesTable.setEditedRule(null);
  };

  return (
    <Card className='flex flex-col flex-1 rounded-tl-none min-h-0' noShadow>
      {renderQuery({
        query: rulesTable.rulesQuery,
        renderStaleDataOnMount: true,
        success: () => (
          <Table
            borderless
            bulkActions={rulesTable.bulkActions}
            className='flex-1 bg-transparent'
            columns={rulesTable.columns}
            description={rulesTableDescription}
            disableTableRowDetail
            id='settings-discovery-data-enrichment-rules'
            loadRowIdsForSelectAll='fromData'
            menuItems={rulesTable.menuItems}
            rowHeight={44}
            rowIdField='id'
            title='Rules'
            {...rulesTable.frontendSimpleFilter}
          />
        ),
      })}
      {rulesTable.confirmDeleteDialog.render()}
      {rulesTable.editedRule === 'new' ? (
        <RuleForm
          formType='add'
          onClose={closeRuleForm}
          onSave={saveRuleForm}
        />
      ) : rulesTable.editedRule !== null ? (
        <RuleForm
          formType='edit'
          rule={rulesTable.editedRule}
          onClose={closeRuleForm}
          onSave={saveRuleForm}
        />
      ) : null}
    </Card>
  );
};
